import { isEmpty } from 'lodash';
import { MessagePlugin } from 'tdesign-react';

import { RichMediaValue } from '@/interface/media';
import { transformObjectDeep } from '@/utils/tans/object';

import { apiPathServer } from './api-config';
import { CgiErrorCode, CgiResp } from './cgi';
import {
  API_BOTH_PREFIX_TRPC,
  API_PREFIX_PLOT,
  API_PREFIX_TRPC,
  API_PREFIX_WOA_AUTH,
  request,
} from './request';

/**
 *  获取权限列表
 * @param param
 * @returns
 */
export const fetchAuthList = async () => {
  const res = await request(`${API_PREFIX_PLOT}${apiPathServer.GetAuth}`);
  if (res?.code !== CgiErrorCode.NO_ERROR) {
    MessagePlugin.error(res.message || res.msg || '后台服务错误，请稍后重试');
  }
  return res;
};

interface IGetUserSigRequest {
  expiration?: number;
}

interface IUserSig {
  userSig: string;
  expireAt: number;
}

interface UserInfo {
  data: {
    userInfo: {
      avatar: RichMediaValue;
      nickName: string;
    };
  };
  code: number;
}

export const fetchUserSig = async (req: IGetUserSigRequest): Promise<string> => {
  const res = await request<CgiResp<IUserSig>>(
    `${API_BOTH_PREFIX_TRPC}${apiPathServer.userSig}`,
    {
      method: 'POST',
      body: transformObjectDeep(req, 'snake'),
    },
  );
  return (
    (transformObjectDeep(res?.data || {}, 'camel') as IUserSig)?.userSig || ''
  );
};

export const fetchUserInfo = async (userId: string): Promise<UserInfo> => {
  const res = await request<UserInfo>(
    `${API_BOTH_PREFIX_TRPC}${apiPathServer.GetUserInfo}`,
    {
      method: 'POST',
      body: transformObjectDeep({ userId: `${userId}` }, 'snake'),
    },
  );
  return (transformObjectDeep(res, 'camel') as UserInfo) || '';
};

export const fetchWoaUserInfo = async () => {
  const res = await request<CgiResp<{ loginname: string }>>(`${API_PREFIX_WOA_AUTH}${apiPathServer.GetWoaUserInfo}`);
  return res?.data?.loginname || '';
};

/**
 *
 * @returns 获取绑定信息
 */
export const getBindUserInfo = async (vuid: string) => {
  const res = await request<CgiResp<{ union_ids: string[] }>>(`${API_PREFIX_TRPC}${apiPathServer.getBindInfo}`, {
    method: 'POST',
    body: transformObjectDeep({
      appId: '1000005',
      userId: `${vuid}`,
    }, 'snake'),
  });
  if (res.code !== 0) {
    throw new Error(res.message || res.msg || '后台服务错误，请稍后重试');
  }

  return (res?.data?.union_ids || []).length > 0;
};

export const fetchLogin = async (params: {
  appType: number; // cms
  baseInfo: {
    id: string;
  };
  userInfo: {
    head: string;
    nick: string;
  };
}): Promise<UserInfo> => {
  const res = await request<UserInfo>(
    `${API_PREFIX_TRPC}${apiPathServer.Login}`,
    { method: 'POST', body: transformObjectDeep({ ...params }, 'snake') },
  );
  return (transformObjectDeep(res, 'camel') as UserInfo) || '';
};

export const fetchBindQrcode = async () => {
  const res = await request<CgiResp<{ qrcode: string; }>>(
    `${API_PREFIX_TRPC}${apiPathServer.getBindQrcode}`,
    { method: 'POST' },
  );
  if (res.code !== 0 || isEmpty(res.data.qrcode)) {
    throw new Error(res.message || res.msg || '后台服务错误，请稍后重试');
  }
  return res?.data?.qrcode || '';
};
